(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./Keyboard.less", "../icon", "./ClassicBoard", "./ModernBoard", "./ClassicBoardIdcard"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./Keyboard.less"), require("../icon"), require("./ClassicBoard"), require("./ModernBoard"), require("./ClassicBoardIdcard"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.Keyboard, global.icon, global.ClassicBoard, global.ModernBoard, global.ClassicBoardIdcard);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _Keyboard, _icon, _ClassicBoard, _ModernBoard, _ClassicBoardIdcard) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _icon = _interopRequireDefault(_icon);
  _ClassicBoard = _interopRequireDefault(_ClassicBoard);
  _ModernBoard = _interopRequireDefault(_ModernBoard);
  _ClassicBoardIdcard = _interopRequireDefault(_ClassicBoardIdcard);

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  var boards = {
    classic: _ClassicBoard.default,
    modern: _ModernBoard.default,
    classicIdcard: _ClassicBoardIdcard.default
  };
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "keyboard",
        attrs: {
          "nx-popup-aria-auto-focus": "true",
          "aria-label": "当前数字金盘"
        }
      }, [_c('div', {
        class: ['keyboard--head', _vm.boardType !== 'classic' ? '' : 'classic--keyboard--head']
      }, [_c('div', {
        staticClass: "keyboard--head--logo"
      }, [!_vm.keyBoardIcon ? _c('div', {
        staticClass: "logo-img"
      }) : _c('img', {
        staticClass: "logo-img-nobg",
        attrs: {
          "src": _vm.keyBoardIcon,
          "alt": ""
        }
      })]), _c('span', {
        staticClass: "keyboard--head--addon right"
      }, [!_vm.hideClose ? _c('nx-icon', {
        attrs: {
          "name": "down",
          "aria-label": "键盘隐藏",
          "tabindex": "-1",
          "role": "button"
        },
        nativeOn: {
          "click": function click($event) {
            return _vm.$emit('close');
          }
        }
      }) : _vm._e()], 1)]), _c(_vm.borderComponent, {
        tag: "component",
        attrs: {
          "hide-dot": _vm.hideDot,
          "show-num": _vm.showNum,
          "show-id": _vm.showId
        },
        on: {
          "delete": function _delete($event) {
            return _vm.$emit('delete');
          },
          "confirm": function confirm($event) {
            return _vm.$emit('confirm');
          },
          "input": function input($event) {
            return _vm.$emit('output', $event);
          },
          "close": function close($event) {
            return _vm.$emit('close');
          }
        }
      })], 1);
    },
    name: 'keyboard',
    components: _objectSpread(_objectSpread({}, boards), {}, (0, _defineProperty2.default)({}, _icon.default.name, _icon.default)),
    props: {
      hideDot: {
        type: Boolean,
        default: false
      },
      hideClose: {
        type: Boolean,
        default: false
      },
      showNum: {
        type: Boolean,
        default: false
      },
      showId: {
        type: Boolean,
        default: false
      },
      boardType: {
        board: String,
        default: 'classic'
      },
      keyBoardIcon: {
        type: String
      }
    },
    computed: {
      borderComponent: function borderComponent() {
        return boards[this.boardType] ? this.boardType : 'classic';
      }
    }
  };
  _exports.default = _default;
});